<template>
  <button class="burger" :class="{ open: isOpen }" @click="$emit('toggle', !isOpen)">
    <span class="line"></span>
  </button>
</template>

<script>
export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.burger {
  width: 24px;
  height: 24px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 6px 4px;

  .line {
    position: relative;
    width: 100%;
    height: 2px;
    background-color: #020617;
    border-radius: 1px;
    transition: background-color 0.3s ease;

    &::before,
    &::after {
      content: "";
      display: block;
      position: absolute;
      width: 100%;
      height: 2px;
      background-color: #020617;
      border-radius: 1px;
      transition: all 0.3s ease;
    }

    &::before {
      top: -6px;
    }

    &::after {
      top: 6px;
    }
  }

  &.open {
    .line {
      background-color: transparent !important;

      &::before {
        top: 0;
        transform: rotate(45deg);
      }

      &::after {
        top: 0;
        transform: rotate(-45deg);
      }
    }
  }
}
</style>
